import { useFeatureGate } from "@statsig/react-bindings";
import {
  clientUserAuthGate,
  preSessionReflectionsGate,
} from "../../statsig/gates";
import { useParams } from "react-router-dom";
import { useGetReflectionTopicCountQuery } from "./useGetReflectionTopicCountQuery";
import { useContext } from "react";
import { StatsigLoadingContext } from "../../statsig/StatsigProvider";

export function useGetShouldShowReflectionTopics() {
  const { patientShortId } = useParams();
  const { value: isPreSessionReflectionsEnabled } = useFeatureGate(
    preSessionReflectionsGate,
  );
  const { value: isClientUserAuthEnabled } = useFeatureGate(clientUserAuthGate);
  const { data: reflectionTopicCount, loading: reflectionTopicCountLoading } =
    useGetReflectionTopicCountQuery(patientShortId ?? "");
  const isStatsigLoading = useContext(StatsigLoadingContext);
  const isLoading = isStatsigLoading || reflectionTopicCountLoading;
  const shouldShowReflectionTopics =
    isPreSessionReflectionsEnabled &&
    isClientUserAuthEnabled &&
    reflectionTopicCount?.patient.reflectionTopics.totalCount > 0;
  return {
    shouldShowReflectionTopics,
    isLoading,
  };
}
